import React from "react";
import { Select } from "antd";
import { useTranslation } from "react-i18next";
import NoDataComponent from "./NoData"; // Adjust path if needed

const { Option } = Select;

export type OptionType = {
  value: string;
  label: string;
};

interface CommonSelectProps {
  options: OptionType[];
  value?: string;
  className?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
}

const CommonSelect: React.FC<CommonSelectProps> = ({
  options,
  value,
  className,
  onChange,
  placeholder,
}) => {
  const { t } = useTranslation();

  return (
    <Select
      className={className}
      value={value}
      onChange={onChange}
      placeholder={placeholder || t("select")}
      style={{ width: "100%" }}
      notFoundContent={<NoDataComponent />}
    >
      {options.map((opt) => (
        <Option key={opt.value} value={opt.value}>
          {opt.label}
        </Option>
      ))}
    </Select>
  );
};

export default CommonSelect;
